import "regenerator-runtime/runtime";

import React, { Component } from "react";

// import InfiniteList from "react-infinite-scroll-list";
import { InfiniteScroll } from "react-simple-infinite-scroll";

const createPlaceholderElement = (items = []) =>
  new Array(25).fill(null).map((_, index) => {
    const value = items.length + index;

    return {
      id: value,
      message: `Placeholder ${value}`
    };
  });

class VerticalList2 extends Component {
  constructor(props) {
    super(props);

    console.log("items: ", props);

    let items;
    props.initialItems
      ? (items = JSON.parse(props.initialItems))
      : (items = []);

    this.state = {
      items: items,
      isLoading: false,
      isEndReached: false
    };

    this.onReachThreshold = this.onReachThreshold.bind(this);
  }

  async onReachThreshold() {
    console.log("onReachThreshold");

    this.setState({ isLoading: true });

    console.log("loading...");

    let response = await fetch(
      `/fashion/infinite_load_more?page=${this.state.items.length}`
    );

    let data = await response.json();
    console.log("data: ", data);

    this.setState(({ items }) => {
      return {
        isLoading: false,
        items: items.concat(data)
      };
    });
  }

  renderItems = () => {
    return this.state.items.map(item => (
      <div key={item.id} dangerouslySetInnerHTML={{ __html: item.html }} />
    ));
  };

  render() {
    return (
      <div class="fashion-vertical">
        <InfiniteScroll
          throttle={100}
          threshold={2000}
          isLoading={this.state.isLoading}
          hasMore={!this.state.isEndReached}
          onLoadMore={this.onReachThreshold}
        >
          {this.renderItems()}

          {this.state.isLoading && (
            <li className="InfiniteList__Item">Loading...</li>
          )}
        </InfiniteScroll>
      </div>
    );
  }
}

export default VerticalList2;
